import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
const DropdownSelect = ({ options, dropdownName, onDropdownSelect, dropdownPlaceholder, dropdownKey }) => {
    const [dropdownValue, setDropdownValue] = useState(null);
    useEffect(() => {
        onDropdownSelect({
            [dropdownKey]: dropdownValue
        });
    }, [dropdownValue]);
    return (React.createElement(Dropdown, null,
        React.createElement(Dropdown.Toggle, { id: dropdownName }, dropdownValue || dropdownPlaceholder),
        React.createElement(Dropdown.Menu, null, options.map(option => {
            return (React.createElement(Dropdown.Item, { key: option, eventKey: option, active: dropdownValue === option, onSelect: (e) => setDropdownValue(e) }, option));
        }))));
};
export default DropdownSelect;
